var _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "285 127 122 288.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    stroke: "currentColor",
    id: "svg_6",
    height: 121,
    width: 112,
    y: 200,
    x: 290,
    strokeWidth: 10,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "svg_7",
    y2: 149,
    x2: 346,
    y1: 198,
    x1: 346,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "none"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    stroke: "currentColor",
    id: "svg_8",
    y2: 322,
    x2: 347,
    y1: 371,
    x1: 347,
    strokeWidth: 10,
    fill: "none"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "svg_9",
    y2: 176,
    x2: 290,
    y1: 152,
    x1: 346,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "none"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "svg_10",
    y2: 175,
    x2: 401,
    y1: 152,
    x1: 343,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "none"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "svg_11",
    y2: 155,
    x2: 401,
    y1: 132,
    x1: 343,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "none"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "svg_12",
    y2: 156,
    x2: 290,
    y1: 132,
    x1: 346,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "none"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(43 319 382)",
    id: "svg_14",
    y2: 394,
    x2: 291,
    y1: 370,
    x1: 347,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "none"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-45 373 381.5)",
    id: "svg_15",
    y2: 393,
    x2: 402,
    y1: 370,
    x1: 344,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "white"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(-44 373 361.5)",
    id: "svg_16",
    y2: 373,
    x2: 402,
    y1: 350,
    x1: 344,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "white"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    transform: "rotate(43 319 362)",
    id: "svg_17",
    y2: 374,
    x2: 291,
    y1: 350,
    x1: 347,
    strokeWidth: 10,
    stroke: "currentColor",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnector);
export default __webpack_public_path__ + "static/media/connector.f77e3938cfc1a15f1ea019dfcf4d5da5.svg";
export { ForwardRef as ReactComponent };